'use client';

import { Trans } from '@lingui/macro';
import { useLingui } from '@lingui/react';
import { Button } from '@mui/material';
import { Application, useRouter } from '@prismo-io/router';
import type { LanguageCodeT } from '@prismo-io/schemas';
import { type FC, useCallback, useTransition } from 'react';
import { useKickFormation } from '../../hooks/use-kick-formation';

type Props = {
  stepIdx: number;
};

export const SkipFormationBtn: FC<Props> = (props) => {
  const { stepIdx } = props;

  const { trigger: kick, isMutating: isSubmitting } = useKickFormation();

  const [isTransiting, startTransition] = useTransition();

  const router = useRouter();

  const { i18n } = useLingui();

  const onSkip = useCallback(() => {
    kick(undefined, {
      onSuccess: () => {
        startTransition(() => {
          router.push({
            app: Application.ONBOARDING,
            path: '/parcours/etapes/:step',
            params: {
              step: stepIdx + 1,
            },
            locale: i18n.locale as LanguageCodeT,
          });
        });
      },
    });
  }, [kick, startTransition, router, stepIdx, i18n.locale]);

  return (
    <Button
      variant="text"
      color="gray"
      onClick={onSkip}
      disabled={isTransiting || isSubmitting}
    >
      <Trans>Passer</Trans>
    </Button>
  );
};
